import { useEffect } from 'preact/hooks'
import { useAuth } from '../auth/useAuth'
import { useLocation } from 'preact-iso'
import { defaultWorkspace } from '@/utils/workspaceSelection'

export function RootRedirect() {
  const { isAuthenticated, isLoading, userProfile, allWorkspaces } = useAuth()
  const location = useLocation()

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated && userProfile && allWorkspaces) {
        // User is authenticated, redirect to dashboard with proper URL structure
        const clientCompanyId = userProfile.ClientCompanyId
        // Get workspaces for user's home company
        const homeWorkspaces = allWorkspaces.filter(w => w.ClientCompanyId === clientCompanyId)
        const landingWorkspaceId = defaultWorkspace(homeWorkspaces)?.Id || ''

        if (clientCompanyId && landingWorkspaceId) {
          location.route(`/company/${clientCompanyId}/workspace/${landingWorkspaceId}/dashboard`)
        } else {
          // This shouldn't happen in normal flow - user should have company/workspace data
          console.error('Missing clientCompanyId or companyWorkspaces data for authenticated user')
          // Redirect to login if we can't construct proper URL
          location.route('/login')
        }
      } else if (!isAuthenticated) {
        // User is not authenticated, redirect to login
        location.route('/login')
      }
    }
  }, [isAuthenticated, isLoading, userProfile, allWorkspaces, location])

  // Show loading while checking authentication status
  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600 mb-4"></div>
          <p className="text-lg text-slate-600 dark:text-slate-300">Loading...</p>
        </div>
      </div>
    )
  }

  // Don't render anything while redirecting
  return null
}
